import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { tenantCommand } from '../../model/const/command';
import { Contact } from '../../model/contact';
import { DwellingService } from '../data/dwelling.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { BrokerInformationFormComponent } from '../../component/broker-information-form/broker-information-form.component';

@Injectable()
export class PrintBrokerInformationCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector,
    private _service: DwellingService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === rentalObjectCommand.printBrokerInformation && command.context;
  }

  execute(command: CommandBase): Observable<boolean | void> {
    if (command instanceof Command) {
      return this._actionService.open(BrokerInformationFormComponent, this._injector, null, command.context, false).pipe(
        map(res => {
          if (res) {
            return true;
          }
          return false;
        })
      );
    }
  }
}
